import {useAuth0} from '@auth0/auth0-react';
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import Auth0Loading from './Auth0Loading';
import ErrorUtils from 'utils/error-utils';
import AuthenticationAPI from 'api/authentication';
import useConfig from 'hooks/use-config';
import {redirect} from 'utils/window';
import ExperimentUtils, {IMMEDIATE_FEATURES} from 'utils/experiment';
import useAuth0APISetup from './useAuth0APISetup';

const Auth0Callback = ({history}) => {
    const {loginWithRedirect, isAuthenticated, isLoading} = useAuth0();
    const {isReady} = useAuth0APISetup();
    const {siteUrl} = useConfig();

    useEffect(() => {
        if (isLoading) {
            return;
        }

        // check if there's a next param provided to redirect the user back to their original page
        const urlParams = new URLSearchParams(history?.location.search);
        const encodedNextParam = urlParams.get('next');
        const nextParam = encodedNextParam
            ? decodeURIComponent(encodedNextParam)
            : null;

        if (!isAuthenticated) {
            // redirect to the appropriate login page based on the feature flag
            ExperimentUtils.isFeatureEnabled(
                IMMEDIATE_FEATURES.AUTH0_ROLLOUT_FEATURE
            )
                ? loginWithRedirect()
                : redirect(`${siteUrl}/login${history.location.search || ''}`);

            return;
        }

        if (isReady) {
            const redirectUser = async () => {
                await AuthenticationAPI.setCookie();

                redirect(
                    nextParam
                        ? `${siteUrl}${nextParam}`
                        : `${siteUrl}/account-settings/`
                );
            };

            redirectUser().catch(error => {
                ErrorUtils.sendSentryError(error);

                history?.push('/auth/error/');
            });
        }
    }, [
        isAuthenticated,
        isReady,
        history,
        siteUrl,
        loginWithRedirect,
        isLoading,
    ]);

    return <Auth0Loading />;
};

Auth0Callback.propTypes = {
    history: PropTypes.object,
};

export default Auth0Callback;
